import { OPERATOR_LABELS } from '../../../constants';

/**
 * Creates a default empty condition group with one blank condition.
 */
export const createDefaultConditionGroup = () => ({
  logic: 'AND',
  conditions: [{ field: '', operator: '', value: '' }],
  groups: [],
});

/**
 * Recursively counts all conditions across a condition group tree.
 */
export const countConditions = (group) => {
  if (!group) return 0;
  const direct = (group.conditions || []).length;
  const nested = (group.groups || []).reduce(
    (sum, g) => sum + countConditions(g),
    0
  );
  return direct + nested;
};

/**
 * Builds a human-readable summary label from a condition group tree.
 * e.g. "total > 100 AND (source = web OR source = app)"
 */
export const buildConditionLabel = (group, maxLength = 60) => {
  if (!group) return 'Set condition';

  const describeCondition = (c) => {
    const f = c.field || '...';
    const op = OPERATOR_LABELS[c.operator] || '...';
    const v = c.value !== undefined && c.value !== '' ? c.value : '...';
    return `${f} ${op} ${v}`;
  };

  const describeGroup = (g, isRoot) => {
    const parts = [
      ...(g.conditions || []).map(describeCondition),
      ...(g.groups || []).map((sub) => describeGroup(sub, false)),
    ];
    if (parts.length === 0) return '(empty)';
    const joined = parts.join(` ${g.logic || 'AND'} `);
    return isRoot ? joined : `(${joined})`;
  };

  const full = describeGroup(group, true);
  if (full.length <= maxLength) return full;
  return full.substring(0, maxLength - 3) + '...';
};
